module.exports = __webpack_public_path__ + "static/img/12.ffc4d46.png";


//////////////////
// WEBPACK FOOTER
// ./src/ally/assets/images/12.png
// module id = 5qBc
// module chunks = 0